import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import PageHero from "@/components/site/PageHero";
import { PillButton } from "@/components/site/Kit";
import { lastRoom } from "@/lib/room";
import { track } from "@/lib/track";

const SEEN = "nomus-paid";

// Where Stripe sends a client after they pay. What happens next depends on
// what they bought.
const NEXT = {
  audit: {
    text: "Thank you. Open your private page with the link in our email. The next step is waiting there: picking the day we start.",
    link: ["The Audit, day by day", "/audit"],
  },
  small_tool: {
    text: "Thank you. Within 24 hours we write to you with the few things we need to start on your tool.",
    link: ["What each price buys", "/pricing"],
  },
};

export default function Paid() {
  const [params] = useSearchParams();
  const offer = params.get("offer");
  // Paid from their own page on this device: take them straight back to it.
  const [page] = useState(() => (offer === "audit" ? lastRoom() : ""));
  const navigate = useNavigate();
  const next = NEXT[offer] || {
    text: "Thank you. Within 24 hours you get an email from us with the next step.",
    link: ["What each price buys", "/pricing"],
  };
  useEffect(() => {
    try {
      if (window.sessionStorage.getItem(SEEN)) return;
      window.sessionStorage.setItem(SEEN, "1");
    } catch {
      // Without storage a reload may count twice; better than not counting.
    }
    track("payment_completed", { offer: NEXT[offer] ? offer : "other" });
  }, [offer]);
  useEffect(() => {
    if (page) navigate(`/a/${page}?paid=1`, { replace: true });
  }, [page, navigate]);
  if (page) return null;
  return (
    <div data-testid="paid-page">
      <PageHero label="Payment received" title="Paid." text={next.text} />
      <section className="px-5 pt-16 lg:pt-24">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="max-w-[620px] text-[20px] leading-[1.3] tracking-[-0.02em] sm:text-[26px]">
            Stripe has sent your receipt by email. If anything looks wrong,
            write to hello@nomus.work and a person answers.
          </p>
          <PillButton to={next.link[1]} size="lg">
            {next.link[0]}
          </PillButton>
        </div>
      </section>
    </div>
  );
}
